import $ from 'jquery';
import screenSize from '../services/screen_size';
import debounceRAF from '../utils/debounce_animation_frame';
import featureFlags from '../../../../../feature_flags';

class ReadingBar {
    constructor() {
    }

    on() {
        const isSponsored = $('.-custom-content').length;
        if (screenSize.getSize() !== 'small' && screenSize.getSize() !== 'medium' && !isSponsored) {
            const $window = $(window);
            this.$readingBar = $('.reading-bar');
            this.$readingAfter = $('.reading-bar-progress');
            this.onScrollFn = this.onScroll.bind(this);
            this.onResizeFn = this.onScroll.bind(this);
            this.running = true;

            $window.on('scroll', debounceRAF(this.onScrollFn));
            $window.on('resize', debounceRAF(this.onResizeFn));

            this.postFull = document.querySelector('.fc-post-full') || document.querySelector('.fc-short-reads');
            if (this.$readingBar.hasClass('fast-feed')) {
                this.isFastFeed = true;
                this.getArticleBounds();

                this.currentArticleSpan = this.$readingAfter.find('.current-article')[0];
                if (this.$readingBar.find('.total-articles')) {
                    this.$readingBar.find('.total-articles').html(this.articleBounds.length - 1);
                }
            } else {
                this.appearAt = $('header').height();
            }
            this.onScroll();
        }
    }

    onScroll() {
        var postFullHeight = this.postFull.offsetHeight;
        var docHeight = document.body.scrollHeight - window.innerHeight;
        var progressHeight = postFullHeight <= docHeight ? postFullHeight : docHeight;
        if (window.scrollY > this.appearAt) {
            this.$readingBar.css({top: 0});
        } else {
            this.$readingBar.css({top: '-60px'});
        }

        if (featureFlags.postInfiniteScroll === false) {
            this.setProgressBar(window.scrollY / progressHeight);
        } else {
            this.setProgressBar(0);
        }

        if (this.isFastFeed) {
            let currentArticle = this.getCurrentArticle(window.scrollY);
            if (this.currentArticleSpan) {
                this.currentArticleSpan.innerHTML = currentArticle;
            }
        }
    }

    setProgressBar(percent) {
        this.$readingAfter.css({width: `${percent * 100}%`});
    }

    getArticleBounds() {
        let articles = this.postFull.querySelectorAll('article h2');
        this.articleBounds = [];
        [].forEach.call(articles, article => {
            this.articleBounds.push((article.getBoundingClientRect().bottom | 0) + window.scrollY - 300);
        });
        this.appearAt = this.articleBounds[1];
    }

    getCurrentArticle(scrollY) {
        var currentIndex = 0;
        for (let i = 0; i < this.articleBounds.length; i++) {
            if (scrollY > this.articleBounds[i]) currentIndex = i;
        }

        return currentIndex || 1;
    }
}

export default new ReadingBar();
